import { render, staticRenderFns } from "./ErrorLogsAdmin.vue?vue&type=template&id=d6385406&scoped=true"
import script from "./ErrorLogsAdmin.vue?vue&type=script&lang=js"
export * from "./ErrorLogsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6385406",
  null
  
)

export default component.exports